import Button from "@builder/components/general/Button";
import "./style.scss";

const IframePlaceholder = () => {
    return (
        <div className="iframe-placeholder">
            <Button buttonStyle="secondary" className="add-img-src" icon={{ src: "./embeded-content-icon.svg" }} />
        </div>
    );
};

export default IframePlaceholder;
